export interface MwaVimeoPlayerSize {
  width?: number;
  height?: number;
}

/**
 * Embed options for MWA Vimeo players.
 * `volume: true` shows Vimeo's volume slider in the player chrome so members
 * can recover when Vimeo.com session volume carries over (KINDLY-1259).
 * `transparent: false` keeps a portrait video inside the wide frame. With the
 * default transparent player, Vimeo shrinks the control bar to the video.
 */
export function createMwaVimeoPlayerOptions(videoId: string, size?: MwaVimeoPlayerSize): Record<string, unknown> {
  const width = size?.width ?? 336;
  const height = size?.height ?? (size?.width ? Math.round((size.width * 9) / 16) : 189);

  return {
    id: parseInt(videoId, 10),
    autoplay: false,
    controls: true,
    volume: true,
    cc: true,
    fullscreen: true,
    quality_selector: true,
    progress_bar: true,
    responsive: false,
    transparent: false,
    width,
    height,
    background: false,
  };
}
